import React from 'react';
import EventOverview from '../components/events/EventOverview';

const Dashboard = () => {

    return (<EventOverview myEvents={false} />);
}

export default Dashboard;